export const color = [
  "#fecaca",
  "#fde68a",
  "#d9f99d",
  "#bbf7d0",
  "#99f6e4",
  "#e9d5ff",
  "#f5d0fe",
];
